import { useState, useContext } from 'react'
import { SignInFormValues } from '../components/SignInForm'
import { AxiosError } from 'axios'
import { encryptAsRsa, hash } from 'helpers/authentification'
import { axiosDefaultConfig } from 'constants/axios'
import { AuthApi, Configuration, UserRoleEnum } from 'generated/api'
import { IListRoles, UserContext, UserTypes } from 'context/UserContext'
import { disableBackPage } from 'helpers/disableBackPage'
import { decodeJWT } from 'helpers/jwtDecode'

export enum errorMessageEnum {
  BAD_REQUEST = 'Nomor telepon dan PIN tidak sesuai.',
  GENERAL_ERROR = 'Tidak dapat terhubung ke server, silakan mencoba kembali.',
}

const axiosConfig = new Configuration(axiosDefaultConfig)
const authApi = new AuthApi(axiosConfig)

export const useLogin = () => {
  const [, dispatch] = useContext(UserContext)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const onSubmit = async (values: SignInFormValues) => {
    try {
      setLoading(true)
      setErrorMessage('')
      const response = await authApi.authPinValidate(
        {
          phoneNumber: encryptAsRsa(values.phone_number),
          pin: hash(values.pin),
        },
        'ADMIN_WEB',
      )

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const fetchDecodeRoles = decodeJWT(response.headers['x-jwt']) as Partial<IListRoles>

      const roles = fetchDecodeRoles.roles
      const rolesEnum = [
        UserRoleEnum.WarehouseOfficer,
        UserRoleEnum.Operation,
        UserRoleEnum.FinanceAccountant,
        UserRoleEnum.Administrator,
        UserRoleEnum.OperationLead,
        UserRoleEnum.FinanceLead,
      ]
      const fetchDecode = {
        role: roles?.filter(list => rolesEnum.includes(list))[0],
      }
      const role = fetchDecode.role
      const filterRole = role && rolesEnum.includes(role)
      if (!filterRole) throw new Error()
      dispatch({
        type: UserTypes.SIGN_IN,
        payload: {
          token: response.headers['x-jwt'] || null,
          userInfo: { role },
        },
      })

      disableBackPage()
      setLoading(false)
    } catch (err) {
      const error = err as AxiosError
      const responseStatus = error.response?.status
      const expectedResponseStatus = [400, 401, 404]
      if (responseStatus && expectedResponseStatus.includes(responseStatus)) {
        setErrorMessage(errorMessageEnum.BAD_REQUEST)
        setLoading(false)
      } else {
        setErrorMessage(errorMessageEnum.GENERAL_ERROR)
        setLoading(false)
      }
    }
  }

  return { loading, errorMessage, onSubmit }
}
